var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b2b-overlay',{attrs:{"persistent":_vm.persistent,"role":"dialog"},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}},[_c('b2b-card',{attrs:{"width":"512","fill-height":""}},[_c('b2b-list-customers',{on:{"click:item":_vm.$_onClickItem}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }